import { simplePath } from "../../utils.js";
import joi from "joi";
import { notificationUpdateList } from "./interfaces.js";
const POST_EMAIL_OPTIONS = 'v2/user-profile-settings/email-options';
function post_email_options_path() {
    return simplePath(POST_EMAIL_OPTIONS, {});
}
const schema = joi.object({
    privacyOptions: joi.object({
        isPrivate: joi.boolean().required()
    }),
    notificationsActivity: joi.object({
        value: joi.string().valid(...notificationUpdateList).required(),
        label: joi.string().required(),
        receiveNotifications: joi.boolean().required()
    }),
    additionalEmails: joi.array().items(joi.string().email({
        tlds: false
    })).required()
}).required();
export { POST_EMAIL_OPTIONS, post_email_options_path, schema };
